import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://krishimart-back.onrender.com/api/v2";

// Thunks
export const createShop = createAsyncThunk("shop/create", async (formData) => {
  const res = await axios.post(`${BASE_URL}/create-shop`, formData);
  return res.data;
});

export const loginShop = createAsyncThunk("shop/login", async (credentials) => {
  const res = await axios.post(`${BASE_URL}/login-shop`, credentials, {
    withCredentials: true,
  });
  return res.data;
});

export const getSeller = createAsyncThunk("shop/getSeller", async () => {
  const res = await axios.get(`${BASE_URL}/getSeller`, { withCredentials: true });
  return res.data;
});

export const logoutShop = createAsyncThunk("shop/logout", async () => {
  const res = await axios.get(`${BASE_URL}/logout`, { withCredentials: true });
  return res.data;
});

// Slice
const shopSlice = createSlice({
  name: "shop",
  initialState: { seller: null, loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createShop.pending, (state) => { state.loading = true; })
      .addCase(createShop.fulfilled, (state, action) => {
        state.loading = false;
        state.seller = action.payload.seller;
      })
      .addCase(loginShop.fulfilled, (state, action) => {
        state.seller = action.payload.seller;
      })
      .addCase(getSeller.fulfilled, (state, action) => {
        state.seller = action.payload;
      })
      .addCase(logoutShop.fulfilled, (state) => {
        state.seller = null;
      });
  },
});

export default shopSlice.reducer;
